@if (data['matIcon']) {
  <mat-icon data-tfa="snack-error-icon">{{data['matIcon']}}</mat-icon>
  }&nbsp;{{data['error'].message}}
